import { render, staticRenderFns } from "./subDatalist.vue?vue&type=template&id=2d85d516"
import script from "./subDatalist.vue?vue&type=script&lang=js"
export * from "./subDatalist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports